/**
 * Throws an error with the given message. And returns never.
 * Useful for when you want to make sure that a function never returns a non null value
 * return some.value ?? panic('some.value is null/undefined')
 * Will tell typescript to never return null/undefined
 */
export function panic(msg: string): never {
  throw new Error(msg);
}
